import { useState, useEffect } from "react";
import Axios from "axios";
import { ListGroup, ListGroupItemText } from "reactstrap";
import { NavLink } from "react-router-dom";

const MineArticles = ({ userID }) => {
  const [articleDetails, setArticleDetails] = useState([]);

  const fetchAllDetailsOfArticles = async () => {
    try {
      const res = await Axios.get(`https://blogappserver-8sw1.onrender.com/../articles/details/${userID}`);
      setArticleDetails(res.data);
    } catch (error) {
    }
  };

  useEffect(() => {
    if (userID) {
      fetchAllDetailsOfArticles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID]);

  //count number of articles..
  var count = 0;

  return (
    <>
      {articleDetails.map((adetail) => {
        count++;
        return (
          <>
              <ListGroup>
                <NavLink to={`/articles/${adetail._id}`}>
                  <ListGroupItemText className="my-0 px-1">
                    <span className="fw-bold mx-1">{count}:</span>
                    {adetail.title} [type:{adetail.articleType}]
                  </ListGroupItemText>
                </NavLink>
              </ListGroup>
          </>
        );
      })}
    </>
  );
};

export default MineArticles;
